import { createAction } from 'helpers/redux-actions.helper'
import { ActionsUnion } from 'helpers/types.helper'
import { IAreaModel } from 'models/area.model'

export const HIERARCHY_UPLOAD = 'HIERARCHY_UPLOAD'
export const HIERARCHY_UPLOAD_SUCCESS = 'HIERARCHY_UPLOAD_SUCCESS'
export const HIERARCHY_LIST_GET = 'HIERARCHY_LIST_GET'
export const HIERARCHY_LIST_SUCCESS = 'HIERARCHY_LIST_SUCCESS'

export const Actions = {
  hierarchyUploadSuccess: (data: any) => createAction(HIERARCHY_UPLOAD_SUCCESS, data),
  hierarchyListSuccess: (data: IAreaModel[], total: number, perPage: number, sort: any[]) => createAction(HIERARCHY_LIST_SUCCESS, { data, total, perPage, sort }),
}

export type Actions = ActionsUnion<typeof Actions>
